<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2022-11-01 09:55:17
 * @LastEditors: 李绍烽 shaofeng.li@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\SatisfactionRate\SatisfactionRateInfo.vue
 * @Description: 
 */
 -->

 <template>
  <div class="satisfaction-rate-info">
    <div class="detail-box">
      <div class="content-name">{{ detailData.GCMC }}</div>
      <div class="content-box">
        <div class="progress-cell">
          <div class="progress-title title">多测合一<br />业务编号</div>
          <div class="progress-value title">{{ detailData.YWBH }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">提交时间</div>
          <div class="progress-value">{{ detailData.CREATETIME || '-'}}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">项目编号</div>
          <div class="progress-value">{{ detailData.GGZH || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">工程地点</div>
          <div class="progress-value">{{ detailData.GCXXDD || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">建设单位</div>
          <div class="progress-value">{{ detailData.JSDW || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">受理时间</div>
          <div class="progress-value">{{ detailData.SJRQ || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">测绘单位</div>
          <div class="progress-value">{{ detailData.CHDW || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">联系人/联系电话</div>
          <div class="progress-value">{{ detailData.LXR_LXDH || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">是否有操作</div>
          <div class="progress-value">{{ detailData.haveOperation || '-' }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">当前状态</div>
          <div class="progress-value">
            <span
              class="status grey"
              :class="{
                yellow: detailData.DQZT == '测量中',
                red: detailData.DQZT == '被退件' || detailData.DQZT == '被退回',
                green: detailData.DQZT == '待确认',
                blue: detailData.DQZT == '测量完成',
              }"
              >{{ detailData.DQZT }}</span
            >
          </div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">委托事项及测量状态</div>
        </div>
        <van-collapse v-model="activeNames">
          <van-collapse-item
            :title="item.CLSXValue"
            :name="index"
            v-for="(item, index) in rowsList"
            :key="index"
            style="text-align: center"
          >
            <div
              class="progress-cell"
              v-for="(column, cIndex) in columns"
              :key="cIndex"
            >
              <div class="progress-title">{{ column.label }}</div>
              <div class="progress-value">
                <span v-if="column.key == 'CLBG'">
                  <span
                    v-for="(file, f) in item['CLBG']"
                    :key="f"
                    :class="{ 'progress-file': file.FJMC }"
                    @click="toFile(file)"
                  >
                    {{ file.FJMC ? file.FJMC : file.isUpload }}
                  </span>
                </span>
                <span v-else-if="column.key == 'MYDPJ'" 
                  :class="{ 'progress-file': item[column.key] != '待完成后评价' }"
                  @click="toSatisfyRate(item)">
                  {{ item[column.key] }}
                </span>
                <span
                  v-else-if="
                    column.key != 'CZ' ||
                    (column.key == 'CZ' && item[column.key])
                  "
                >
                  {{ item[column.key] }}
                </span>
                <span v-else
                  ><span
                    class="progress-confirm"
                    :class="{ 'btn-isEnabled': !item.haveConfirm }"
                    @click="handleConfirm(item)"
                    >确认</span
                  >
                  <span
                    class="progress-return"
                    :class="{ 'btn-isEnabled': !item.haveConfirm }"
                    @click="toReturn(item)"
                    >退回</span
                  >
                </span>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="evaluate" v-if="allEvaluat">
          <div
            class="evaluate-btn"
            :class="{ 'btn-isEnabled': allEvaluat == '待完成后评价' }"
            @click="toSatisfyRate()"
          >
            {{ allEvaluat == '已完成' ? '查看评价' : allEvaluat }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from '@/utils/api/projectProgress.api.js'
import commonApi from '@/utils/api/common'
import moduleMixins from '@/mixins/moduleMixins'
import listMixins from '@/mixins/comListMixins'
export default {
  name: 'SatisfactionRateInfo',
  mixins: [listMixins, moduleMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      detailData: {},
      rowsList: [], // 信息列表
      columns: [], // 列表子项的左侧标题数组
      activeNames: [],
      allEvaluat: '',
      showReturn: false,
      returnMessage: '',
      returnData: {},
      detailYWBH:"",// 详情项值
      list:[],//
      finished: false,

    }
  },
  watch: {
  },
  computed: {
    navTitle() {
      // return this.$route.query.title
      return '满意度评价详情'

    }
  },
  methods: {
    // 撤回
    refundEntrust() {
      this.$dialog
        .confirm({
          message: '确定撤回该项目委托？',
          confirmButtonColor: '#1D84FF',
        })
        .then(() => {
          api
            .surveyRecall({ rid: this.detailData.RID })
            .then((res) => {
              console.log('撤回:', res)
              this.$toast.success('撤回成功')
            })
            .catch(() => {
              this.$toast.fail('撤回失败')
            })
        })
        .catch(() => {})
    },
    toSatisfyRate(item) {
      console.log("toSatisfyRate:",item);
      // 值为`待完成后评价`只显示字不可点击
      // 值为`已完成`时可点击查看评价详情【根据获取的满意度维度获取对应的值】
      // 分项值为'点击评价'，总体值为`评价`时候可点击进行评价
      let params = {},
        title = ''
      
      params = {
        rid: item.RID,
        YWBH: item.YWBH,// 业务编号
        CHCGZL:item.CHCGZL,// 满意度评价--测绘成果质量
        CKFWZL:item.CKFWZL,// 满意度评价--服务质量
        RYSZ:item.RYSZ,// 满意度评价--人员素质
        FWPY:item.FWPY,// 满意度评价--服务评语
        MYDPJ: item.MYDPJ,// 满意度评价
      }
      // 满意度评价分为总体评价及分项评价
      if(item.allEvaluat) {
        title = item.allEvaluat
        // 总体评价
        this.isEnabled = (title == '评价' || title == '点击评价') ? true : false// 1.待完成后评价 2.点击评价/评价 3.已完成
        if(item.MYDPJ == '评价' || item.MYDPJ == '点击评价' || item.MYDPJ == '已完成') {
          params.isEnabled = this.isEnabled
        }
      } else {
        // 分项评价
        title = item.MYDPJ
        this.isEnabled = (title == '评价' || title == '点击评价') ? true : false// 1.待完成后评价 2.点击评价/评价 3.已完成
        if(item.MYDPJ == '评价' || item.MYDPJ == '点击评价' || item.MYDPJ == '已完成'){
          params.isEnabled = this.isEnabled // 是否可评价
          params.HJINDEX = item.HJINDEX // 汇交次数 
          params.CLSX = item.CLSX // 测量事项
        }
      }

      if(title == '待完成后评价') return
      this.$router.push({
        name: 'SatisfactionRate',
        params
      })
    },
    toFile(file) {
      if (file.FJLJ) {
        //文件
        console.log('file', file)

        const params = this.UrlParamHash(file.FJLJ)
        console.log('params', params)
        let url =
          'macroPath=' +
          params['macroPath'] +
          '&fileName=' +
          decodeURI(params['fileName'])

        if (window.__wxjs_environment === 'miniprogram') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: '/pages/downloadFile/downloadFile?' + url,
          })
        } else {
          this.$toast.fail('请使用小程序预览')
        }
      }
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    },
    // 获取项目进度查询和办理详情列表
    loadData(res) {
      console.log('--res', res)
      if(!res.MYDPJ) {
        return
      }
      this.allEvaluat = res.MYDPJ.allEvaluat // 总体评价
      let arr = res.MYDPJ['columns'].filter(
        (item) => !res.MYDPJ['hideColumns'].includes(item.key)
      )
      res.MYDPJ.rowsList.forEach((element, index) => {
        element.CLSXValue = this.$store.state.projectCode[element.CLSX]// 展示测量事项名称
        // console.log('MYDPJ----', element)
        element.haveConfirm = element.CLZT == '待确认' ? true : false
        if (element.haveConfirm) {
          // 展开
          this.activeNames.push(index)
        }
      })
      //去除测试事项，因为在收缩板标题显示
      let CLSXCurrentIdx = arr.findIndex((itm) => itm.key == 'CLSX')
      arr.splice(CLSXCurrentIdx, 1)

      let czCurrentIdx = arr.findIndex((itm) => itm.key == 'CZ') //找到数组columns中key=CZ的下标索引(从0开始)
      console.log('操作项的索引值：', czCurrentIdx)
      let currentColumns = arr.splice(czCurrentIdx, 1) // 输出移除数组columns中key=CZ的对象[操作对象]
      console.log('currentColumns::', currentColumns, arr)
      arr.push(currentColumns[0]) // 将"操作"项添加至尾部

      this.columns = arr
      this.rowsList = res.MYDPJ['rowsList']
      // this.$set(this.rowsList,'MYDPJ',res.MYDPJ['rowsList'])// 更新满意度评价状态
    },
    getListData(data){
      let params = {
        page: data.page,
        rows: data.rows,
        pageSize: data.rows,// 接口是用pageSize
        keyword: this.detailYWBH,
        type: 7,
      }
      return api.getProjectList(params).then(res => {
        console.log('--res', res.data.rowsList)
        this.columns = res.data.columns
        if (data.page == 1) {
          this.list = res.data.rowsList
        } else {
          this.list.push(...res.data.rowsList)
        }
        this.finished = this.list.length >= res.data.total
        this.detailData = this.list[0]
        this.$set(this.detailData,'MYDPJ',this.list[0].MYDPJ)// 更新满意度评价状态
        this.loadData(this.detailData)
        return Promise.resolve(res)
      })
    },
    satisfyListOnload(){
      let params = {
        page: 1,
        rows: 20,
        pageSize: 20,// 接口是用pageSize
        keyword: this.detailYWBH,
        type: 7,
      }
      this.getListData(params)
    },
  },
  filters:{
    getCLSXText(val,that){
      let projectCodeArr = that.projectCode
      for(let i = 0; i < projectCodeArr.length; i++){
        if(projectCodeArr[i].code == val){
          return projectCodeArr[i].showValue
        }
      }
    },
  },
  created() {
    // this.onRefresh()
  },
  mounted() {
    //判断是否有中间页
    this.title = this.$route.query.title
    console.log(this.$route.params)
    this.detailData = this.$route.params
    this.detailYWBH = this.$route.params.YWBH 
    // let params = {
    //   page: 1,
    //   rows: 20,
    //   pageSize: 20,// 接口是用pageSize
    //   keyword: this.detailYWBH,
    //   type: 7,
    // }
    // this.getListData(params)

    this.loadData(this.detailData)
    this.$bus.$on('satisfyListOnload', () => {
      this.satisfyListOnload()
      
    })
  },
  activated(){
  },
}
</script>
<style lang="scss" scoped>
.satisfaction-rate-info {
  // background: #ffffff;
  height: 100vh;
  .detail-box {
    background: #f1f3f6;
    padding: 0px 16px;
    .content-name {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding-top: 20px;
      // margin-bottom: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
      z-index: 1;
      background: #f1f3f6;
      width: 100%;
      height: 46px;
    }
    .content-box {
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
      border-radius: 5px;
    }
    .progress-cell {
      display: flex;
      align-items: center;
      padding: 4px 14px;
      .progress-title {
        font-size: 14px;
        font-weight: 500;
        color: #999999;
        width: 28%;
        text-align: right;
        padding: 5px 0px;
        &.title {
          font-weight: bold;
          color: #333333;
        }
      }
      .progress-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        border-radius: 1px;
        color: #333333;
        margin-left: 24px;
        text-align: left;
        &.title {
          font-weight: bold;
          color: #333333;
        }
        .status {
          padding: 4px 10px;
          &.grey {
            color: #333;
            background-color: #ddd;
          }
          &.yellow {
            color: #d78534;
            background-color: #ffebcc;
          }
          &.red {
            color: #fa6366;
            background-color: #ffd5d5;
          }
          &.green {
            color: #34cc8c;
            background-color: #dcf4ea;
          }
          &.blue {
            color: #155ede;
            background-color: #d5e4ff;
          }
        }
        .progress-confirm {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #1d84ff;
          border-radius: 14px;
          padding: 7px 12px;
        }
        .progress-return {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #fa6366;
          border-radius: 14px;
          padding: 7px 12px;
          margin-left: 10px;
        }
        .btn-isEnabled {
          background: #cfcfcf;
        }
        .progress-file {
          display: block;
          color: #3d93ff;
        }
      }
    }
    .evaluate {
      display: flex;
      justify-content: flex-end;
      padding: 14px;
      .evaluate-btn {
        border-radius: 14px;
        padding: 6px 12px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        background: #1d84ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
        text-align: center;
      }
      .btn-isEnabled {
        background: #cfcfcf;
        box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
      }
    }
    .btn-group {
      width: 100%;
      padding: 20px 0;
      margin: 30px 0;
      text-align: center;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 45%;
      }
    }
  }
  .return-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: calc(100vw - 60px);
    padding: 0px 30px;
    .return-content {
      background: #ffffff;
      width: 100%;
      padding: 18px 15px;
      border-radius: 5px;
      .return-content-icon {
        display: flex;
        justify-content: flex-end;
      }
      .border-message {
        background: #ffffff;
        border: 1px solid #f1f3f6;
        border-radius: 1px;
        margin: 18px 0px;
      }
    }
  }
}
</style>
